class EdenShopV3 extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-eden-v3-rail-button]');
      if (!button || !this.contains(button)) return;
      const rail = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
      if (!rail) return;
      const direction = button.dataset.edenV3RailButton === 'previous' ? -1 : 1;
      rail.scrollLeft += direction * Math.max(rail.clientWidth * 0.82, 280);
    });

    this.querySelectorAll('[data-eden-v3-dialog-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.edenV3DialogOpen);
        if (dialog?.showModal) dialog.showModal();
      });
    });

    this.querySelectorAll('[data-eden-v3-dialog-close]').forEach((button) => {
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });

    this.querySelectorAll('[data-eden-v3-combined-buy]').forEach((button) => {
      button.addEventListener('click', async () => {
        if (button.dataset.loading === 'true') return;

        const primaryVariant = Number(button.dataset.primaryVariant);
        const secondaryVariant = Number(button.dataset.secondaryVariant);
        const status = this.querySelector('[data-eden-v3-cart-status]');
        const originalLabel = button.textContent;

        if (!primaryVariant || !secondaryVariant) {
          if (status) status.textContent = 'This combined membership is not ready to add to the cart.';
          return;
        }

        button.dataset.loading = 'true';
        button.disabled = true;
        button.textContent = 'Adding…';
        if (status) status.textContent = 'Adding both memberships to the cart.';

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                { id: primaryVariant, quantity: 1 },
                { id: secondaryVariant, quantity: 1 },
              ],
            }),
          });

          if (!response.ok) throw new Error(`Cart request failed with ${response.status}`);
          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (error) {
          button.dataset.loading = 'false';
          button.disabled = false;
          button.textContent = originalLabel;
          if (status) status.textContent = 'We could not add both memberships. Please review each membership separately or try again.';
        }
      });
    });

    this.querySelectorAll('dialog').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  }
}

if (!customElements.get('eden-shop-v3')) {
  customElements.define('eden-shop-v3', EdenShopV3);
}
